import styled, { css } from 'styled-components';

// Import styles
import { flex, customMinResponsive, size } from '../../../styles';

export const Info = styled.p`
	font-size: 1.2rem;
	margin-top: 0.6rem;
	margin-bottom: 1rem;
	color: ${({ theme }) => theme.product.lightBackground.color};
	opacity: 0.5;
	${flex({ jc: 'flex-start' })}

	${customMinResponsive(
		size.medium,
		css`
			font-size: 1.8rem;
			margin-top: 1.5rem;
			margin-bottom: 3.3rem;
		`
	)}
`;

export const Divider = styled.span`
	display: inline-block;
	height: 1.2rem;
	width: 2px;
	border-radius: 4px;
	margin: 0 0.5rem;
	z-index: 2;
	opacity: ${({ opacity }) => opacity || 1};

	${customMinResponsive(
		size.medium,
		css`
			height: 1.6rem;
			margin: 0 1rem;
		`
	)}

	${({ theme, isLightBackground }) =>
		isLightBackground
			? css`
					background-color: ${theme.product.lightBackground.color};
			  `
			: css`
					background-color: ${theme.product.coverBackground.color};
			  `};
`;
